var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490.544 490.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.098 274.151L245.213 47.015l227.115 227.136c4.237 4.093 10.99 3.975 15.083-.262a10.666 10.666 0 000-14.821L252.744 24.401c-4.165-4.164-10.917-4.164-15.083 0L2.994 259.068c-4.093 4.237-3.975 10.99.262 15.083 4.134 3.992 10.687 3.992 14.82 0h.022z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.765 216.38c-4.165-4.164-10.917-4.164-15.083 0L3.016 451.047c-4.093 4.237-3.976 10.99.262 15.083a10.666 10.666 0 0014.821 0l227.115-227.115 227.115 227.136c4.237 4.093 10.99 3.976 15.083-.261 3.993-4.134 3.993-10.688 0-14.821L252.765 216.38z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.88 277.266a10.663 10.663 0 01-7.552-3.115L245.213 47.015 18.098 274.151c-4.237 4.093-10.99 3.975-15.083-.262-3.992-4.134-3.992-10.687 0-14.82L237.682 24.401c4.165-4.164 10.917-4.164 15.083 0l234.667 234.667c4.159 4.172 4.148 10.926-.024 15.085a10.667 10.667 0 01-7.528 3.113z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M479.88 469.266a10.663 10.663 0 01-7.552-3.115L245.213 239.015 18.098 466.151c-4.237 4.093-10.99 3.976-15.083-.262a10.666 10.666 0 010-14.821l234.667-234.667c4.165-4.164 10.917-4.164 15.083 0l234.667 234.667c4.159 4.172 4.148 10.926-.024 15.085a10.667 10.667 0 01-7.528 3.113z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.cdbb6293.svg";
export { ForwardRef as ReactComponent };